var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.273,
    height: 70,
    viewBox: "0 0 57.273 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.636,1,3,13.727V32.818C3,50.477,15.218,66.991,31.636,71c16.418-4.009,28.636-20.523,28.636-38.182V13.727Zm0,34.968H53.909C52.223,49.077,43.473,60.755,31.636,64.414V36H9.364V17.864l22.273-9.9v28Z",
    transform: "translate(-3 -1)",
    fill: "#0533b3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.d3203f0d9f16d2b6ba620c08d3e689df.svg";
export { ForwardRef as ReactComponent };